import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import { setSpecialReportSubCategories } from '../store/options.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getSpecialReportSubCategories() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)

  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getSpecialReportSubCategories])
    const { entity } = response
    if (entity) {
      yield put(setSpecialReportSubCategories(entity))
    }
  } catch (e) {
    yield put(throwPcrException(`getSpecialReportSubCategories() error: ${e}`))
  }
}

export function* getSpecialReportSubCategoriesSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getSpecialReportSubCategories)
}
